/**
 * @generated SignedSource<<ff61e3d5ca495db510537b3d38a737a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ModalInviteAcceptInviteMutation$variables = {
  id: string;
};
export type ModalInviteAcceptInviteMutation$data = {
  readonly acceptInvite: {
    readonly failed: boolean | null;
    readonly message: string | null;
    readonly success: boolean | null;
  };
};
export type ModalInviteAcceptInviteMutation = {
  response: ModalInviteAcceptInviteMutation$data;
  variables: ModalInviteAcceptInviteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ErrorableResponse",
    "kind": "LinkedField",
    "name": "acceptInvite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "failed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ModalInviteAcceptInviteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ModalInviteAcceptInviteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9b5ca2a43d0df95225d8bec54c2bfcca",
    "id": null,
    "metadata": {},
    "name": "ModalInviteAcceptInviteMutation",
    "operationKind": "mutation",
    "text": "mutation ModalInviteAcceptInviteMutation(\n  $id: ID!\n) {\n  acceptInvite(id: $id) {\n    message\n    failed\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "f8d32705a70834ee4c73d6f3bff0789a";

export default node;
